<template>
  <div class="LogisticssPop" :style="{ '--root-font-size': rootFontSize }">
    <van-popup v-model="isShow" safe-area-inset-bottom>
      <div class="LogisticssPop__main">
        <van-swipe
          class="swipe_logisticss"
          :show-indicators="false"
          :width="'100%'"
          @change="onSipeChangeHandle"
          v-if="logisticssInfo && logisticssInfo.info"
        >
          <van-swipe-item
            v-for="(item, index) in logisticssInfo.info"
            :key="index"
          >
            <div class="logisticss__card">
              <div class="logisticss__card-header">
                <div class="header__info">
                  <div class="header__top">
                    <img
                      :src="getLogisticssStatusIcon(item)"
                      class="logisticss_status-icon"
                    />
                    <span class="logisticss_status-text">{{ item.state }}</span>
                  </div>
                  <div class="header__bottom">
                    {{ logisticssInfo.address }}
                  </div>
                </div>
                <div class="header__order">
                  <span class="header__order-label"
                    >{{ item.logistic_name }}：</span
                  >
                  <span class="header__order-num">{{
                    item.logistic_code
                  }}</span>
                  <button class="header__order-copy" @click="onCopyLogisticCodeHandle(item.logistic_code)">复制</button>
                </div>
              </div>
              <div
                class="logisticss__card-content"
                v-if="item.traces && item.traces.length"
              >
                <div class="content__title">物流跟踪</div>
                <div class="logisticss__list">
                  <div
                    class="logisticss__li"
                    v-for="(traceInfo, idx) in item.traces"
                    :key="idx"
                  >
                    <div class="logisticss__li-left">
                      <img
                        :class="['node_icon', idx === 0 ? '' : 'dot_icon']"
                        :src="
                          idx === 0
                            ? require('@/image/yky/物流进度.png')
                            : require('@/image/yky/pcsss@2x.png')
                        "
                        alt=""
                      />
                    </div>
                    <div
                      :class="[
                        'logisticss__li-right',
                        idx !== 0 ? 'complete' : '',
                      ]"
                    >
                      {{ traceInfo.accept_station }}
                      <div class="right-time">{{ traceInfo.accept_time }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </van-swipe-item>
        </van-swipe>
        <div class="swipe-dot" v-if="logisticssInfo && logisticssInfo.info">
          <div class="dot-list" >
            <div :class="['dot-li', idx===swipeIndex ? 'active':'']" v-for="(_,idx) in logisticssInfo.info" :key="idx"></div>
          </div>
        </div>
        <div class="LogisticssPop__logo">
          <img class="logoIcon" src="@/image/yky/凯儿得乐新logo-02@2x.png" />
        </div>
      </div>
      <div class="LogisticssPop__footer">
        <img
          class="closeIcon"
          src="@/image/yky/编组 9@2x.png"
          @click="onCloseHandle"
        />
      </div>
    </van-popup>
  </div>
</template>

<script>
import qianShou from "@/image/yky/编组 11备份@2x.png";
import lanShou from "@/image/yky/已发货备份@2x.png";
import zaiTu from "@/image/yky/编组 20@2x.png";
import daiFa from "@/image/yky/暂无物流信息@2x.png";
import wenTi from "@/image/yky/问题件@2x.png";
import { Toast } from 'vant'
export default {
  props: {
    show: Boolean,
    logisticssInfo: Object,
  },
  data() {
    return {
      rootFontSize: 1,
      swipeIndex: 0,
    };
  },
  computed: {
    isShow: {
      get() {
        return this.show;
      },
      set(newVal) {
        this.$emit("update:show", newVal);
      },
    },
  },
  mounted() {
    this.getRootEleFontSize();
  },
  methods: {
    // 获取根元素的字体大小
    getRootEleFontSize() {
      const fontSize = getComputedStyle(
        document.documentElement,
        null
      ).fontSize;
      this.rootFontSize = parseFloat(fontSize);
    },
    // 获取物流状态图
    getLogisticssStatusIcon(info) {
      // 签收、已揽收、在途中、待发货、问题件
      const statusIconObj = {
        签收: qianShou,
        已揽收: lanShou,
        在途中: zaiTu,
        待发货: daiFa,
        问题件: wenTi,
      };
      return statusIconObj[info.state];
    },
    onSipeChangeHandle(index) {
      this.swipeIndex = index;
    },
    onCloseHandle() {
      this.isShow = false;
    },
    // 复制物流单号
    async onCopyLogisticCodeHandle(logisticCode){
      await this.$copyText(logisticCode)
      Toast({message:"复制成功"})
    }
  },
};
</script>

<style scoped lang="scss">
@function px2rem($px) {
  $rootFontSize: var(--root-font-size);
  @return calc(1rem * $px / $rootFontSize);
}
.LogisticssPop {
  .van-popup {
    background: transparent;
  }
  .LogisticssPop__main {
    width: px2rem(343);
    height: px2rem(500);
    background: #cde8f8;
    border-radius: px2rem(20);
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: px2rem(12) 0;
    overflow: hidden;
    .swipe_logisticss {
      height: px2rem(392);
      width: 100%;
      .van-swipe-item {
        display: flex;
        justify-content: center;
      }
      .logisticss__card {
        width: px2rem(319);
        height: px2rem(392);
        background: #ffffff;
        border-radius: px2rem(14);
        padding: px2rem(16) px2rem(12);
        padding-bottom: 0;
        overflow-y: auto;
      }
      .logisticss__card-header {
        padding-bottom: px2rem(12);
        border-bottom: px2rem(1) solid #f5f8fb;
        .header__top {
          display: flex;
          align-items: center;
          .logisticss_status-icon {
            width: px2rem(22);
            height: px2rem(22);
            border-radius: px2rem(11);
          }
          .logisticss_status-text {
            font-size: px2rem(16);
            font-family: PingFangSC, PingFang SC;
            font-weight: bold;
            color: #222222;
            line-height: px2rem(24);
            margin-left: px2rem(8);
          }
        }
        .header__bottom {
          width: px2rem(182);
          font-size: px2rem(12);
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: px2rem(18);
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          text-overflow: ellipsis;
          overflow: hidden;
          margin-left: px2rem(30);
          margin-top: px2rem(4);
        }
        .header__order {
          display: flex;
          align-items: center;
          margin-top: px2rem(14);
          .header__order-label {
            font-size: px2rem(13);
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #222222;
            line-height: px2rem(20);
          }
          .header__order-num {
            font-size: px2rem(13);
            font-family: PingFangSC, PingFang SC;
            font-weight: bold;
            color: #222222;
            line-height: px2rem(20);
          }
          .header__order-copy {
            width: px2rem(38);
            height: px2rem(20);
            border-radius: px2rem(11);
            border: px2rem(1) solid rgba(125, 184, 220, 0.5);
            background: transparent;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: px2rem(11);
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #7db8dc;
            line-height: px2rem(18);
            margin-left: px2rem(10);
          }
        }
      }
      .logisticss__card-content {
        .content__title {
          font-size: px2rem(14);
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          color: #222222;
          line-height: px2rem(21);
          padding-top: px2rem(12);
        }
        .logisticss__list {
          .logisticss__li {
            display: flex;
            & + .logisticss__li {
              .logisticss__li-right {
                border-top: px2rem(1) solid #f5f8fb;
              }
            }
            &:first-child {
              .logisticss__li-left {
                &::before {
                  visibility: hidden;
                }
              }
            }
            &:last-child {
              .logisticss__li-left {
                &::after {
                  visibility: hidden;
                }
              }
            }
            .logisticss__li-left {
              display: flex;
              flex-direction: column;
              align-items: center;
              width:px2rem(22);
              flex-shrink: 0;
              &::before,
              &::after {
                content: "";
                display: block;
                border-right: px2rem(1) solid rgba(0, 60, 113, 0.2);
                flex: 1;
              }
              .node_icon {
                border-radius: 50%;
                width: px2rem(22);
                height: px2rem(22);
                margin: px2rem(8) 0;
                &.dot_icon {
                  width: px2rem(8);
                  height: px2rem(8);
                }
              }
            }
            .logisticss__li-right {
              font-size: px2rem(13);
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              color: #222222;
              line-height: px2rem(20);
              padding: px2rem(12) 0;
              margin-left: px2rem(12);
              flex-grow: 1;
              .right-time {
                margin-top: px2rem(8);
              }
              &.complete {
                color: #999;
              }
            }
          }
        }
      }
    }
    .swipe-dot {
      margin-top: px2rem(9);
      .dot-list {
        display: flex;
        justify-content: center;
        .dot-li {
          width: px2rem(6);
          height: px2rem(6);
          background: #ffffff;
          border-radius: px2rem(3);
          &.active {
            background: #7db8dc;
          }
          & + .dot-li {
            margin-left: px2rem(8);
          }
        }
      }
    }
    .LogisticssPop__logo {
      text-align: center;
      margin-top: px2rem(29);
      .logoIcon {
        width: px2rem(100);
        height: px2rem(17);
      }
    }
  }
  .LogisticssPop__footer {
    display: flex;
    justify-content: center;
    .closeIcon {
      width: px2rem(36);
      height: px2rem(36);
      margin-top: px2rem(24);
    }
  }
}
</style>
